import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {SdkComponent} from '../sdk/sdk.component';
import {AnyStyledComponent} from 'styled-components';


export interface GameJackpotComponentProps {
  gameType: number;
  className?: string;
  box?: AnyStyledComponent;
}

export class GameJackpotComponent extends OrbitComponent<GameJackpotComponentProps> {
  render() {
    let sdkProps = {
      gametypeid: this.props.gameType
    };
    return (
        <SdkComponent box={this.props.box} className={this.props.className} componentId={'game_jackpot'} sdkProps={sdkProps}/>
    );
  }
}
